import React, { Component } from 'react';
import './App.css';

import {  BrowserRouter as Router, Route } from 'react-router-dom'

import { Characters } from './components/Characters.js';

class App extends Component {
	
  render() {
    return (
	<Router>
		<div className="Wrapper">
			<Route exact path='/' component={Characters}/>
			<Route path='/:count' component={Characters}/>				
      </div>
	</Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js